import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin, Twitter, Github } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";
import "./MaxFooter.css";

const LOGO_LIGHT_TEXT = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_Dark_01.png`;
const LOGO_DARK_TEXT = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_01.png`;

const MaxFooter = () => {
  const { theme } = useTheme();
  const year = new Date().getFullYear();

  const currentLogo = theme === "dark" ? LOGO_LIGHT_TEXT : LOGO_DARK_TEXT;

  return (
    <footer className="max-footer" id="contact">
      <div className="max-footer__glow-border"></div>
      
      <div className="max-container max-footer__wrap">
        
        <div className="max-footer__top">
          <div className="max-footer__brand">
            <img
              src={currentLogo}
              alt="MaX Consulting Logo"
              className="max-footer__logo"
              width={184}
              height={60}
            />
            <p className="max-footer__desc">
              Precision in Every Shift. Power in Every Asset. 
              Elevating plant operations with next-generation manufacturing technology and 30+ years of domain expertise.
            </p>
          </div>
          
          <div className="max-footer__links-grid">
            <div className="max-footer__column">
              <h4 className="max-footer__col-title">Platform</h4>
              <ul className="max-footer__list">
                <li><Link to="/login" className="max-footer__link">OEE Analytics</Link></li>
                <li><Link to="/login" className="max-footer__link">Planned Maintenance</Link></li>
                <li><Link to="/login" className="max-footer__link">Asset Management</Link></li>
                <li><Link to="/login" className="max-footer__link">Safety & Hazard</Link></li>
              </ul>
            </div>
            
            <div className="max-footer__column">
              <h4 className="max-footer__col-title">Company</h4>
              <ul className="max-footer__list">
                <li><a href="#approach" className="max-footer__link">Our Approach</a></li>
                <li><a href="#core-pillars" className="max-footer__link">Core Pillars</a></li>
                <li><a href="#segments" className="max-footer__link">Segments</a></li>
                <li><a href="mailto:hello@maxconsulting.com" className="max-footer__link">Contact Us</a></li>
              </ul>
            </div>
            
            <div className="max-footer__column">
              <h4 className="max-footer__col-title">Connect</h4>
              <ul className="max-footer__contact-list">
                <li>
                  <Mail size={16} className="max-footer__icon" />
                  <a href="mailto:hello@maxconsulting.com" className="max-footer__link">hello@maxconsulting.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="max-footer__bottom">
          <p className="max-footer__legal">© {year} MaX Consulting. All rights reserved.</p>
          
          <div className="max-footer__social">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="max-footer__social-link" aria-label="LinkedIn">
              <Linkedin size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="max-footer__social-link" aria-label="Twitter">
              <Twitter size={18} />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="max-footer__social-link" aria-label="GitHub">
              <Github size={18} />
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default MaxFooter;
